import React, { ReactNode, useCallback } from "react"
import { ValueType } from "react-select"
import { AsyncProps } from "react-select/src/Async"
import { useLazyGetChannelsQuery } from "../../../../../../../api/controllers/channels/controller"
import { ChannelTypeString } from "../../../../../../../models/channel"
import { ClassProps } from "../../../../../../../utility/common/props"
import AsyncSearchableInput, {
    GetLabelFunction,
    OptionType
} from "../../../../../../AsyncSearchableInput/AsyncSearchableInput"

export interface ChannelSelectProps extends ClassProps {
    id: string
    name: string
    label?: string
    disabled?: boolean
    projectId?: string
    onSelect?: (option: ValueType<OptionType, false>) => void
    getLabel?: GetLabelFunction
    onChange?: (option: ValueType<OptionType, false>) => void
    useValueForDefaultOptions?: boolean
    defaultOptions?: AsyncProps<OptionType>["defaultOptions"]
    icon?: ReactNode
    filter: string[]
}

const WebchatChannelSelect: React.FC<ChannelSelectProps> = props => {
    const {
        className,
        id,
        name,
        label,
        disabled,
        projectId,
        onSelect,
        getLabel,
        onChange,
        useValueForDefaultOptions,
        defaultOptions,
        icon,
        children,
        filter
    } = props

    const [getChannelsTrigger] = useLazyGetChannelsQuery()
    const getIntentOptions = useCallback(async () => {
        if (!projectId) {
            return []
        }

        const { data } = await getChannelsTrigger({ projectId, declarations: {} })
        return (data?.channels ?? [])
            .filter(channel => channel.Type === ChannelTypeString.WebChat && filter.includes(channel.Id))
            .map(channel => {
                return {
                    value: channel.Id,
                    label: channel.Title
                }
            })
    }, [projectId, getChannelsTrigger, filter])

    return (
        <AsyncSearchableInput
            id={id}
            className={className}
            label={
                <>
                    {label}
                    {icon}
                </>
            }
            name={name}
            getOptions={getIntentOptions}
            isDisabled={disabled}
            onSelect={onSelect}
            getCustomLabel={getLabel}
            useValueForDefaultOptions={useValueForDefaultOptions}
            defaultOptions={defaultOptions}
            onChange={onChange}
        >
            {children}
        </AsyncSearchableInput>
    )
}

export default WebchatChannelSelect
